import store from '../../store/store';
import { getLocalStorageTokenKey, isLocalStorageEnabled } from '../../utils/localStorage';
import router from '../routes';

export const IpcCall = {
    Login: 'login',
    Register: 'register',
    Logout: 'logout',
    PaginateCeremonies: 'paginateCeremonies',
    GetCeremonyToControl: 'getCeremonyToControl',
    GetCurrentUser: 'getCurrentUser',
    DownloadCeremony: 'downloadCeremony',
    CheckCeremonyDownloadStatus: 'checkCeremonyDownloadStatus',
    GetExternalCeremony: 'getExternalCeremony',
    GetCurrentUserToken: 'getCurrentUserToken',
    DeleteCeremony: 'deleteCeremony',
    SendCeremonyInvite: 'sendCeremonyInvite',
    CreateCeremony: 'createCeremony',
    UpdateCeremony: 'updateCeremony',
    CheckIfOnline: 'checkIfOnline',
    SetPlayerDisplaySettings: 'setPlayerDisplaySettings',
    GetAllCeremonyUsers: 'getAllCeremonyUsers',
    SaveCeremonyPdfExport: 'saveCeremonyPdfExport',
    DeleteAccount: 'deleteAccount',
    GetConfirmationToken: 'getConfirmationToken',
    ForgotPassword: 'forgotPassword',
    PaginateUsers: 'paginateUsers',
    DeleteUser: 'deleteUser',
    UpdateUser: 'updateUser',
    InviteUser: 'inviteUser',
    UpdateAccount: 'updateAccount',
    UpdatePassword: 'updatePassword',
    DownloadCompanyAssets: 'downloadCompanyAssets',
};

class IpcError extends Error {

    constructor(error) {
        super(error.message);

        Object.assign(this, error);
    }
}

export async function ipcCall(action, data) {
    console.log('Execute IPC call', action, data);

    const response = await window.ipcRenderer.invoke('liteService', {
        action,
        data,
    });

    // Logout on unauthenticated
    if ((store.state.user || store.state.token) && response?.error?.response?.status === 401) {
        store.state.user = null;
        store.state.token = null;
        store.state.loading = false;

        if (isLocalStorageEnabled()) {
            localStorage.removeItem(getLocalStorageTokenKey());
        }

        await router.push({
            name: 'login',
        });
    }

    if (response?.error) {
        throw new IpcError(response.error);
    }

    return response;
}
